import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export const REQUEST_STATE_REDUCER_KEY = 'requestStateReducer';

export const SET_REQUEST_STATE = 'requestState/SET_REQUEST_STATE';
export const SET_FETCHED_CONTAINER_NAME =
  'requestState/SET_FETCHED_CONTAINER_NAME';
export const SET_X_REQUEST_TOKEN = 'requestState/SET_X_REQUEST_TOKEN';
export const SET_REDIRECT = 'requestState/SET_REDIRECT';

let defaultState = fromJS({
  serverRequestInfo: {},
  xRequestToken: null,
  fetchedDataContainerName: [],
  redirectTo: null,
});

export default function (state = defaultState, action) {
  switch (action.type) {
    case SET_REQUEST_STATE:
      return state.merge({
        serverRequestInfo: fromJS(action.serverRequestInfo),
      });

    case SET_X_REQUEST_TOKEN:
      return state.merge(action.xRequestToken);

    case SET_FETCHED_CONTAINER_NAME:
      return state.update(
        'fetchedDataContainerName',
        (fetchedDataContainerName) => {
          return fetchedDataContainerName.push(action.fetchedDataContainerName);
        }
      );

    case SET_REDIRECT:
      return state.set('redirectTo', action.to || null);

    default:
      return state;
  }
}

export function setServerRequestInfo(serverRequestInfo) {
  return {
    type: SET_REQUEST_STATE,
    serverRequestInfo,
  };
}

export function setFetchedContainerName(fetchedDataContainerName) {
  return {
    type: SET_FETCHED_CONTAINER_NAME,
    fetchedDataContainerName,
  };
}

export function setXRequestToken(xRequestToken) {
  return {
    type: SET_X_REQUEST_TOKEN,
    xRequestToken,
  };
}

export const selectServerRequestInfo = (state) => {
  return getIn(state[REQUEST_STATE_REDUCER_KEY], 'serverRequestInfo');
};
